module.exports = __webpack_public_path__ + "static/media/intervencion1.1c0f0644.jpg";